module.exports = __webpack_public_path__ + "img/winning_numbers.1f7d39a1.png";